module.exports = __webpack_public_path__ + "static/media/hero-1.5cdd04b1.jpg";